"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDialogHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var Button_1 = require("../../../atoms/Button/Button");
var CloseButton_1 = require("../../../atoms/CloseButton/CloseButton");
var LabelTag_1 = require("../../../atoms/LabelTag/LabelTag");
var Typography_1 = require("../../../atoms/Typography/Typography");
var BaseDialogHeader_static_1 = require("./BaseDialogHeader.static");
var BaseDialogHeader_style_1 = __importDefault(require("./BaseDialogHeader.style"));
/**
 * BaseDialogHeader molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-basedialog-basedialogheader--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/BaseDialog/BaseDialogHeader Source}
 */
var BaseDialogHeader = function (_a) {
    var title = _a.title, onClose = _a.onClose, isContentAtTop = _a.isContentAtTop, isLoading = _a.isLoading, _b = _a.actions, actions = _b === void 0 ? {} : _b, optional = _a.optional, subtitle = _a.subtitle, className = _a.className;
    var classes = (0, BaseDialogHeader_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, !isContentAtTop && classes.collapsed, className) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.titleContainer }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: isContentAtTop ? 'headline1' : 'headline3', className: classes.title, transition: theme_1.default.transitions.easeOutFast, breakWord: true, numberOfLines: 1 }, { children: title })), subtitle && (0, jsx_runtime_1.jsx)(Typography_1.Typography, { children: subtitle }), optional && (0, jsx_runtime_1.jsx)(LabelTag_1.LabelTag, { label: 'Optional' })] })), (0, lodash_1.isEmpty)(actions) && onClose ? renderBasicCloseButton() : renderActions()] })));
    function renderBasicCloseButton() {
        return ((0, jsx_runtime_1.jsx)(CloseButton_1.CloseButton, { onClick: onClose, className: classes.closeButton, size: isContentAtTop ? 'large' : 'small', transition: theme_1.default.transitions.easeOutFast }));
    }
    function renderActions() {
        var onCancel = actions.onCancel, onAccept = actions.onAccept;
        var determineTooltip = function (action) {
            if (isLoading) {
                return BaseDialogHeader_static_1.localText.loading;
            }
            if (action === null || action === void 0 ? void 0 : action.isDisabled) {
                return action === null || action === void 0 ? void 0 : action.disabledTooltip;
            }
            if (action === null || action === void 0 ? void 0 : action.tooltip) {
                return action === null || action === void 0 ? void 0 : action.tooltip;
            }
            return undefined;
        };
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.actions, !isContentAtTop && classes.actionsScrolled) }, { children: [onCancel && ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: 'secondary', title: onCancel.title, className: onAccept ? classes.buttonMargin : undefined, isDisabled: onCancel.isDisabled, tooltip: determineTooltip(onCancel), onClick: onCancel.handler })), onAccept && ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: 'primary', title: onAccept.title, isDisabled: onAccept.isDisabled, isLoading: isLoading, tooltip: determineTooltip(onAccept), onClick: onAccept.handler }))] })));
    }
};
exports.BaseDialogHeader = BaseDialogHeader;
